/**
 * Checks whether the internal-document warning dialog should be suppressed.
 * The user can dismiss it for 15 days by storing a timestamp in localStorage.
 */
export const getLocalStorageWarningRemover = (): boolean => {
   const previousTimeStampString = localStorage.getItem('hideInteralDocumentWarning');
   if (!previousTimeStampString) return false;

   const currentTimeStamp = new Date();
   const maxTimeStamp = new Date(previousTimeStampString);
   maxTimeStamp.setDate(maxTimeStamp.getDate() + 15); // 15 days, after that the warning will be shown again

   return currentTimeStamp < maxTimeStamp;
};
